// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_UpdateCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/updateCompromisso
 *
 * Indicates success/failure of the compromisso update operation.
 * The model returns a boolean success flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_UpdateCompromissoResponseDados = boolean;

export type Compromissos_UpdateCompromissoResponse = ApiResponse<Compromissos_UpdateCompromissoResponseDados>;

registerResponseContract('Compromissos_UpdateCompromissoResponse', {})
